/* eslint-disable @typescript-eslint/no-explicit-any */
import { type CSSProperties, useId } from "react";
import styles from "./RadioButtons.module.scss";
import { RadioOption } from "./RadioOption";

type Option = {
  title: string;
  value: any;
};

type RadioButtonsProps = {
  options: Option[];
  onChange: (value: any) => void;
  checked: any;
  /** Defaults to a generated id so each group gets its own name. */
  name?: string;
  dark?: boolean;
  isVertical?: boolean;
  optionClassName?: string;
  optionStyle?: CSSProperties;
  optionLabelClassName?: string;
};

export function RadioButtons({
  options,
  onChange,
  dark,
  checked,
  name,
  isVertical,
  optionClassName,
  optionStyle,
  optionLabelClassName,
}: RadioButtonsProps) {
  const generatedName = useId();
  const groupName = name ?? generatedName;

  return (
    <div
      className={`${styles.buttonGroup} ${isVertical ? styles.vertical : ""}`}
    >
      {options.map((radio: Option) => (
        <RadioOption
          key={radio.value}
          name={groupName}
          value={radio.value}
          checked={checked === radio.value}
          onChange={() => onChange(radio)}
          dark={dark}
          className={optionClassName}
          style={optionStyle}
          labelClassName={optionLabelClassName}
        >
          {radio.title}
        </RadioOption>
      ))}
    </div>
  );
}
